import { render, staticRenderFns } from "./5_symptom.vue?vue&type=template&id=20190d80&scoped=true&"
import script from "./5_symptom.vue?vue&type=script&lang=js&"
export * from "./5_symptom.vue?vue&type=script&lang=js&"
import style0 from "./5_symptom.vue?vue&type=style&index=0&id=20190d80&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20190d80",
  null
  
)

export default component.exports